import React from 'react';
import { testimonials } from '../data/musik';
export function Testimonials() {
  if (testimonials.length === 0) return null;
  return <section className="w-full border-t border-slate-900/10 bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-272" data-mp="3kqw4qlswr4gn">
      <div className="mx-auto max-w-6xl" data-id="element-273" data-mp="3fy30dz1cpy53">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-274" data-mp="3b0ufhqotjg05">
          Vad <em className="text-red-700" data-id="element-275" data-mp="36zimrcaneenq">lärarna</em> säger
        </h2>

        <div className="mt-14 grid gap-x-14 gap-y-14 border-t border-slate-900/15 pt-10 md:grid-cols-2" data-id="element-276" data-mp="36wmplq6mju0c">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col" data-id="element-277" data-mp="2x09watezri64">
              <div className="text-sm text-amber-500" aria-label="5 av 5 stjärnor" data-id="element-278" data-mp="2x2mkvpf98qs5">
                <span aria-hidden="true" data-id="element-279" data-mp="2s3tai5v9lfw7">★★★★★</span>
              </div>
              <blockquote className="mt-4 flex-1 font-serif text-xl leading-snug sm:text-2xl text-slate-900" data-id="element-280" data-mp="v8555k5bgowg">
                ”{item.quote}”
              </blockquote>
              <figcaption className="mt-6 text-sm" data-id="element-281" data-mp="h5f03oky0129">
                <span className="font-semibold text-slate-900" data-id="element-282" data-mp="h817no7u2gkh">{item.name}</span>
                <span className="text-slate-900/60" data-id="element-283" data-mp="m6m91qytn6ai"> — {item.location}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}